/********************************************
* Download filters
********************************************/
function fnDownloadFilters( i, oSection ) {

	var oSection			= $( oSection );

	/**
	* Redirect to new URL when filter is selected
	*/
	$( 'select', oSection ).on( 'change', function() {

		var sLink           = $( this ).val();

		window.location     = sLink;

	});

}


// END OF DOCUMENT
